export default __webpack_public_path__ + "static/media/Weerwood Bark.757780ac.PNG";